import {NControlsValidationErrors, NInputErrorMessages} from "./public_components";
import {ErrorMessagesFactory} from "../services/error-messages-factory.service";

const ua = window.navigator.userAgent;
const mobile = /(ip[ao]d|iphone|android)/ig.test(ua);
export function isApple(): boolean {
  return !!(navigator.platform.match(/(Mac|iPhone|iPod|iPad)/i));
}

const touch = ("createTouch" in window.document) && isMobile();
export const isIE = (ua.indexOf("MSIE ") > 0) || (ua.indexOf("Trident/") > 0);

export function buildModifierText(prefix: string, mod: string): string {
  let result = "";
  if (mod) {
    const mods = mod.split(" ");
    for (const m of mods) {
      result += prefix + m + " ";
    }
  }
  return result;
}

export function buildErrorMessage(errors: NControlsValidationErrors,
                                  factory: ErrorMessagesFactory,
                                  messages: NInputErrorMessages | undefined) {

  const displayingMessages = [];

  for (const err in errors) {
    if (errors.hasOwnProperty(err)) {
      if (messages && messages[err]) {
        displayingMessages.push(messages[err]);
      } else {
        return factory.getMessage(err, errors[err]);
      }
    }

  }

  return displayingMessages.join("\r\n");
}

export function isMobile(): boolean {
  return mobile;
}

export function isTouch(): boolean {
  return touch;
}
